// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"_9e1425b4d3--header-wrapper--P0Gof","link":"_9e1425b4d3--link--AsT47"};